import React, { PureComponent } from "react";
import { Row, Col, TreeSelect } from 'antd';
import { Form, Input, Select, Upload, Message, Radio, Layout, Button, DatePicker } from 'element-react';
import "./opinionsMailbox.scss";
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import img from "../../img/home/characteristic/img1.png";
import 'element-theme-default';

export default class opinionsMailbox extends PureComponent {
  constructor(props) {
    super(props);
    this.uploadRef = React.createRef();
    this.state = {
      options: [{//用户类型opt
        value: '',
        label: '请选择'
      }, {
        value: '1',
        label: '士兵'
      }, {
        value: '2',
        label: '干部'
      }],
      userTypeDis: false,//用户类型下拉，默认不禁用
      userType: '', //用户类型：1士兵，2干部
      dicts: [],
      veriCodeImg: '',
      veriCodeAns: '',
      enlistmentTimeOut: '',
      retirementTimeOut: '',

      attachmentNameOut: '',
      attachmentPathOut: '',
      form: {
        attachmentName: '',
        attachmentPath: '',
        name: '',
        sex: '',
        age: '',
        communistStatus: '',
        nation: '',
        education: '',
        idNumber: '',
        permanentAddress: '',
        postalAddress: '',
        enlistmentTime: '',
        retirementTime: '',
        presentSituation: '',
        practiceType: '',

        registeredResidenceType: '',
        retiredSoldierType: '',
        soldiersResettlementMode: '',
        workSituation: '',

        rank: '',
        cadreResettlementMode: '',

        preferentialTreatmentObjectStatus: '',
        preferentialTreatmentObjectCategory: '',
        messageTitle: '',
        messageBody: '',
        businessCategory: '',
        email: '',
        contactNumber: '',
        veriCode: '',
        fileOut: '',
        fileListOut: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        idNumber: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入身份证号'));
              } else {
                if (this.state.form.idNumber !== '') {
                  var pattern = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                  if (!pattern.test(this.state.form.idNumber)) {
                    callback(new Error('请输入正确的证件号码'));
                  }
                }
                callback();
              }
            }
          }
        ],
        sex: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        age: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              var age = parseInt(value, 10);
              setTimeout(() => {
                if (!Number.isInteger(age)) {
                  callback(new Error('请输入数字值'));
                }
              }, 1000);
            }, trigger: 'change'
          }
        ],
        contactNumber: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入联系电话'));
              } else {
                if (this.state.form.contactNumber !== '') {
                  var pattern = /^1[0-9]{10}$/;
                  if (!pattern.test(this.state.form.contactNumber)) {
                    callback(new Error('请输入正确的联系方式'));
                  }
                }
                callback();
              }
            }
          }
        ],
        email: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入电子邮箱'));
              } else {
                if (this.state.form.email !== '') {
                  var pattern = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
                  if (!pattern.test(this.state.form.email)) {
                    callback(new Error('请输入正确的电子邮箱格式'));
                  }
                }
                callback();
              }
            }
          }
        ],
        communistStatus: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        nation: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        education: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        permanentAddress: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],

        postalAddress: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],

        permanentAddress: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        enlistmentTime: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        retirementTime: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        presentSituation: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],

        practiceType: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        registeredResidenceType: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        retiredSoldierType: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        soldiersResettlementMode: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],

        workSituation: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        rank: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        cadreResettlementMode: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        preferentialTreatmentObjectStatus: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],

        preferentialTreatmentObjectCategory: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        messageTitle: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        messageBody: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        businessCategory: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        veriCode: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
      }
    };
  }

  componentDidMount() {
    Http.get(Request.get_dict(), {}, obj => {
      if (obj.code == 200) {
        this.setState({
          dicts: obj.data
        })
      }
    });
    Http.get(Request.getVeriCode(), {}, obj => {
      if (obj) {
        this.setState({
          veriCodeImg: obj.image,
          veriCodeAns: obj.key
        })
      }
    });
  }

  handleSubmit(e) {
    const { form, veriCodeAns ,userType} = this.state;
    e.preventDefault();

    this.refs.form.validate((valid) => {
      console.log('valid1111111', valid, form)

      if (
        form.name == '' ||
        form.sex == '' ||
        form.communistStatus == '' ||
        form.age == '' ||
        form.nation == '' ||
        form.education == '' ||
        form.idNumber == '' ||
        form.permanentAddress == '' ||
        form.postalAddress == '' ||
        form.enlistmentTime == '' ||
        form.retirementTime == '' ||
        form.presentSituation == '' ||
        form.practiceType == '' ||

        form.registeredResidenceType == '' ||
        form.retiredSoldierType == '' ||
        form.soldiersResettlementMode == '' ||
        form.workSituation == '' ||

        form.rank == '' ||
        form.cadreResettlementMode == '' ||

        form.preferentialTreatmentObjectStatus == '' ||
        (form.preferentialTreatmentObjectStatus == "2" && form.preferentialTreatmentObjectCategory == '') ||
        form.messageTitle == '' ||
        form.messageBody == '' ||
        form.businessCategory == '' ||
        form.email == '' ||
        form.contactNumber == '',
        form.veriCode == ''
      ) {
        Message.error('必填项不能为空')
        return false;
      }
      if( form.preferentialTreatmentObjectCategory<=5 && !userType){
        Message.error('所属优抚类型，必须选择用户类型！');
       return false;
      }
      if (valid) {
        console.log(valid);
        let time1 = this.state.retirementTimeOut.getFullYear() + '-' + (this.state.retirementTimeOut.getMonth() + 1) + '-' + this.state.retirementTimeOut.getDate()
        let time2 = this.state.enlistmentTimeOut.getFullYear() + '-' + (this.state.enlistmentTimeOut.getMonth() + 1) + '-' + this.state.enlistmentTimeOut.getDate()
        form.enlistmentTime = time1
        form.retirementTime = time2
        form.attachmentName = this.state.attachmentNameOut;
        form.attachmentPath = this.state.attachmentPathOut;
        Http.hdjlPost(Request.saveDmbMsg(), form, form.veriCode, veriCodeAns, obj => {
          if (obj.code == 200) {
            Message.success('保存成功！');
            this.uploadRef.current.clearFiles()
            this.setState({
              enlistmentTimeOut: '',
              retirementTimeOut: '',
            })
            let form = {
              name: '',
              sex: '',
              age: '',
              communistStatus: '',
              nation: '',
              education: '',
              idNumber: '',
              permanentAddress: '',
              postalAddress: '',
              enlistmentTime: '',
              retirementTime: '',
              presentSituation: '',
              practiceType: '',

              registeredResidenceType: '',
              retiredSoldierType: '',
              soldiersResettlementMode: '',
              workSituation: '',

              rank: '',
              cadreResettlementMode: '',

              preferentialTreatmentObjectStatus: '',
              preferentialTreatmentObjectCategory: '',
              messageTitle: '',
              messageBody: '',
              businessCategory: '',
              email: '',
              contactNumber: '',
              veriCode: '',

            }
            this.setState({
              form: form
            })
            console.log(this.state.attachmentNameOut);
            console.log(this.state.attachmentPathOut);
            this.refs.form.resetFields();
            return;
          } else {
            Message.error(obj.msg);
            return;
          }
        })
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  handleReset(e) {
    e.preventDefault();
    let form = {
      name: '',
      sex: '',
      age: '',
      communistStatus: '',
      nation: '',
      education: '',
      idNumber: '',
      permanentAddress: '',
      postalAddress: '',
      enlistmentTime: '',
      retirementTime: '',
      presentSituation: '',
      practiceType: '',

      registeredResidenceType: '',
      retiredSoldierType: '',
      soldiersResettlementMode: '',
      workSituation: '',

      rank: '',
      cadreResettlementMode: '',

      preferentialTreatmentObjectStatus: '',
      preferentialTreatmentObjectCategory: '',
      messageTitle: '',
      messageBody: '',
      businessCategory: '',
      email: '',
      contactNumber: '',
      veriCode: '',
      fileOut: '',
      fileListOut: '',
    }
    this.setState({
      form: form,
      enlistmentTimeOut: '',
      retirementTimeOut: '',
      attachmentNameOut: '',
      attachmentPathOut: '',
    })
    this.refs.form.resetFields();
  }
  selectchange(value,e){
    const {userType,form}=e.state;
    if( value<=5 && !userType){
      form.preferentialTreatmentObjectCategory=''
      this.setState({
        form:form
      })
      console.log(e);
      Message.error('请选择用户类型');
     return false;
    }
  }
  onChange(key, value) {
    console.log('key-', key)
    // value 对应的是 dictKey
    console.log('val-', value)

    console.log(key, value);
    const {userType,form}=this.state;
    console.log('userType', !userType,userType)
    // if(key=="preferentialTreatmentObjectCategory"&&  value<=5 && !userType){
    //   form.preferentialTreatmentObjectCategory=''
    //   this.setState({
    //     form:form
    //   })
    //   Message.error('请选择用户类型');
    //  return
    // }
    
    // 0: {id: '72', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '1', dictValue: '伤残人员', …}
    // 1: {id: '73', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '2', dictValue: '在乡老复员军人', …}
    // 2: {id: '74', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '3', dictValue: '带病回乡退伍军人', …}
    // 3: {id: '75', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '4', dictValue: '参战退役人员', …}
    // 4: {id: '76', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '5', dictValue: '参试(涉核)退役人员', …}
    // 5: {id: '77', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '6', dictValue: '烈士老年子女', …}
    // 6: {id: '78', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '7', dictValue: '年满60周岁农村籍退役士兵', …}
    // 7: {id: '79', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '8', dictValue: '烈土遗属', …}
    // 8: {id: '80', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '9', dictValue: '因公牺牲军人遗属', …}
    // 9: {id: '81', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '10', dictValue: '病故军人遗属', …}
    // 10: {id: '82', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '11', dictValue: '其他', …}    

    // dictKey > 5 则是：烈士老年子女，年满60周岁农村籍退役士兵，烈土遗属，因公牺牲军人遗属，病故军人遗属，其他
    // if (value > 5) {
    //   this.setState({
    //     userTypeDis: true, //禁用用户类型下拉选择
    //     userType: ''//用户类型置空
    //   })
    // } else {
    //   this.setState({
    //     userTypeDis: false, //启用类型下拉选择
    //     userType: ''//用户类型置空
    //   })
    // }

    this.setState({
      form: Object.assign({}, this.state.form, { [key]: value })
    });

  }

  onBlur(key, e) {
    var value = e.target.value;
    if (value && value != '') {
      if (key == 'idNumber') {
        var pattern = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!pattern.test(value)) {
          Message.error('请输入正确的证件号码');
          this.setState({
            form: Object.assign({}, this.state.form, { [key]: '' })
          });
          return false;
        }
      }
      if (key == 'age') {
        var age = parseInt(value, 10);
        if (!Number.isInteger(age)) {
          Message.error('请输入数字值');
          this.setState({
            form: Object.assign({}, this.state.form, { [key]: '' })
          });
          return false;
        }
      }
      if (key == 'email') {
        var pattern = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!pattern.test(value)) {
          Message.error('请输入正确的电子邮箱');
          this.setState({
            form: Object.assign({}, this.state.form, { [key]: '' })
          });
          return false;
        }
      }
      if (key == 'contactNumber') {
        var pattern = /^1[0-9]{10}$/;
        if (!pattern.test(value)) {
          Message.error('请输入正确的联系方式');
          this.setState({
            form: Object.assign({}, this.state.form, { [key]: '' })
          });
          return false;
        }
      }

      this.setState({
        form: Object.assign({}, this.state.form, { [key]: value })
      });
    }
  }


  handlePreview(file) {
    console.log('preview');
  }

  handleRemove(file, fileList) {
    console.log('remove');
  }
  uploadSuccess(response, file, fileList) {
    this.setState({
      attachmentNameOut: file.name,
      attachmentPathOut: response.data.url,
      fileOut: file,
      fileListOut: fileList,
    })
  }
  changeVCode() {
    Http.get(Request.getVeriCode(), {}, obj => {
      console.log(obj);
      if (obj) {
        this.setState({
          veriCodeImg: obj.image,
          veriCodeAns: obj.key
        })
      }
    });
  }

  // 用户类型选择
  onTypeChange(e) {
    let form =this.state.form;
    form.preferentialTreatmentObjectCategory=''
    this.setState({
      userType: e,
      form:form
    })
    
  }

  render() {
    const { dicts, treeData, form, userType } = this.state;
    const fileList = [];
    let yzmImgStyle = {
      background: `url(${this.state.veriCodeImg}) no-repeat`
    };
    return (
      <div className="complaint-container">
        <Form ref="form" model={this.state.form} rules={this.state.rules} labelWidth="80" className="demo-ruleForm">
          <Row gutter={8}>
            <Col sm={{ span: 24 }} style={{ marginBottom: 24 }}>
              <span className="title">厅长信箱</span>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="姓名" props="name" required={true}>
                <Input placeholder="" value={this.state.form.name} onChange={this.onChange.bind(this, 'name')} maxLength={10}></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="性别" props="sex" required={true}>
                <Select value={this.state.form.sex.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'sex')}>
                  {
                    this.state.dicts.map(el => {
                      if (el.code == 'sex') {
                        let arr = [];
                        if (el.children) {
                          arr = el.children.map((item) => {
                            return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)} />
                          })
                        }
                        return arr;
                      }
                    })
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="年龄" props="age" required={true}>
                <Input placeholder="" value={this.state.form.age} onChange={this.onChange.bind(this, 'age')} onBlur={this.onBlur.bind(this, 'age')} maxLength={10}></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="是否党员" props="communistStatus" required={true}>
                <Select value={this.state.form.communistStatus.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'communistStatus')}>
                  {
                    this.state.dicts.map(el => {
                      if (el.code == 'yes_no') {
                        let arr = [];
                        if (el.children) {
                          arr = el.children.map((item) => {
                            return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)} />
                          })
                        }
                        return arr;
                      }
                    })
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="民族" props="nation" required={true}>
                <Select value={this.state.form.nation.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'nation')}>
                  {
                    this.state.dicts.map(el => {
                      if (el.code == 'nation') {
                        let arr = [];
                        if (el.children) {
                          arr = el.children.map((item) => {
                            return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)} />
                          })
                        }
                        return arr;
                      }
                    })
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="学历" props="education" required={true}>
                <Select value={this.state.form.education.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'education')}>
                  {
                    this.state.dicts.map(el => {
                      if (el.code == 'education') {
                        let arr = [];
                        if (el.children) {
                          arr = el.children.map((item) => {
                            return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)} />
                          })
                        }
                        return arr;
                      }
                    })
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col sm={{ span: 12 }}>
              <Form.Item label="身份证号" props="idNumber" required={true}>
                <Input placeholder="请输入18位身份证号" value={this.state.form.idNumber} onChange={this.onChange.bind(this, 'idNumber')} onBlur={this.onBlur.bind(this, 'idNumber')}></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 12 }}>
              <Form.Item label="户籍地址" props="permanentAddress" required={true}>
                <Input placeholder="请输入您的户籍地址" value={this.state.form.permanentAddress} onChange={this.onChange.bind(this, 'permanentAddress')} onBlur={this.onBlur.bind(this, 'permanentAddress')}></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 12 }}>
              <Form.Item label="通讯地址" props="postalAddress" required={true}>
                <Input placeholder="请输入通讯地址" value={this.state.form.postalAddress} onChange={this.onChange.bind(this, 'postalAddress')} onBlur={this.onBlur.bind(this, 'postalAddress')}></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 12 }}>
              <Form.Item label="电子邮箱" props="email" required={true}>
                <Input placeholder="请输入电子邮箱" value={this.state.form.email} onChange={this.onChange.bind(this, 'email')} onBlur={this.onBlur.bind(this, 'email')}></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 12 }}>
              <Form.Item label="手机号码" props="contactNumber" required={true}>
                <Input placeholder="请输入手机号码" value={this.state.form.contactNumber} onChange={this.onChange.bind(this, 'contactNumber')} onBlur={this.onBlur.bind(this, 'contactNumber')}></Input>
              </Form.Item>
            </Col>

            <Col sm={{ span: 6 }}>
              <Form.Item label="入伍时间" props="enlistmentTime" required={true}>
                <DatePicker
                  // isDisabled={disabled}
                  value={this.state.enlistmentTimeOut}
                  // value={this.state.form.userVeterans ? this.state.form.userVeterans.dischargeTime:''}
                  placeholder="选择日期"
                  // format="yyyy/MM/DD"
                  // onChange={this.onChange.bind(this, 'dischargeTime')}
                  onChange={date => { this.setState({ enlistmentTimeOut: date }) }}
                // onChange={date => {
                //   var time = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
                //   console.log(time);
                //   this.setState({ enlistmentTimeOut: time })
                // }}
                />
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="退役时间" props="retirementTime" required={true}>
                <DatePicker
                  // isDisabled={disabled}
                  value={this.state.retirementTimeOut}
                  // value={this.state.form.userVeterans ? this.state.form.userVeterans.dischargeTime:''}
                  placeholder="选择日期"
                  // format="yyyy/MM/DD"
                  // onChange={this.onChange.bind(this, 'dischargeTime')}
                  onChange={date => { this.setState({ retirementTimeOut: date }) }}
                // onChange={date => {
                //   var time = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
                //   console.log(time);
                //   this.setState({ retirementTimeOut: time })
                // }}
                />
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="现状" props="presentSituation" required={true}>
                <Select value={this.state.form.presentSituation.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'presentSituation')}>
                  {
                    this.state.dicts.map(el => {
                      if (el.code == 'present_situation') {
                        let arr = [];
                        if (el.children) {
                          arr = el.children.map((item) => {
                            return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)} />
                          })
                        }
                        return arr;
                      }
                    })
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="从业类型" props="practiceType" required={true}>
                <Select value={this.state.form.practiceType.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'practiceType')}>
                  {
                    this.state.dicts.map(el => {
                      if (el.code == 'practice_type') {
                        let arr = [];
                        if (el.children) {
                          arr = el.children.map((item) => {
                            return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)} />
                          })
                        }
                        return arr;
                      }
                    })
                  }
                </Select>
              </Form.Item>
            </Col>

            <Col sm={{ span: 24 }} style={{ marginBottom: 24 }}>
              <span className="title">用户类型：</span>

              <Select value={this.state.userType} placeholder="请选择" onChange={this.onTypeChange.bind(this)} disabled={this.state.userTypeDis}>
                {
                  this.state.options.map(el => {
                    return <Select.Option key={el.value} label={el.label} value={el.value} />
                  })
                }
              </Select>
            </Col>
            {userType == 1 ? <Col sm={{ span: 24 }} style={{ "display": "flex" }}>
              <Col sm={{ span: 6 }}>
                <Form.Item label="户籍类型" props="registeredResidenceType" required={true}>
                  <Select value={this.state.form.registeredResidenceType.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'registeredResidenceType')}>
                    {
                      this.state.dicts.map(el => {
                        if (el.code == 'veterans_hr') {
                          let arr = [];
                          if (el.children) {
                            arr = el.children.map((item) => {
                              return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)} />
                            })
                          }
                          return arr;
                        }
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="退役兵类型" labelWidth="100" props="retiredSoldierType" required={true}>
                  <Select value={this.state.form.retiredSoldierType.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'retiredSoldierType')}>
                    {
                      this.state.dicts.map(el => {
                        if (el.code == 'retired_soldier_type') {
                          let arr = [];
                          if (el.children) {
                            arr = el.children.map((item) => {
                              return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)} />
                            })
                          }
                          return arr;
                        }
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="安置方式" props="soldiersResettlementMode" required={true}>
                  <Select value={this.state.form.soldiersResettlementMode.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'soldiersResettlementMode')}>
                    {
                      this.state.dicts.map(el => {
                        if (el.code == 'soldiers_resettlement_mode') {
                          let arr = [];
                          if (el.children) {
                            arr = el.children.map((item) => {
                              return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)} />
                            })
                          }
                          return arr;
                        }
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="工作情况" props="workSituation" required={true}>
                  <Select value={this.state.form.workSituation.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'workSituation')}>
                    {
                      this.state.dicts.map(el => {
                        if (el.code == 'work_situation') {
                          let arr = [];
                          if (el.children) {
                            arr = el.children.map((item) => {
                              return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)} />
                            })
                          }
                          return arr;
                        }
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
            </Col> : (userType == 2 ? <Col sm={{ span: 24 }} style={{ "display": "flex" }}>
              <Col sm={{ span: 6 }}>
                <Form.Item label="职级" props="rank" required={true}>
                  <Select value={this.state.form.rank.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'rank')}>
                    {
                      this.state.dicts.map(el => {
                        if (el.code == 'rank') {
                          let arr = [];
                          if (el.children) {
                            arr = el.children.map((item) => {
                              return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)} />
                            })
                          }
                          return arr;
                        }
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col sm={{ span: 6 }}>
                <Form.Item label="安置方式" props="cadreResettlementMode" required={true}>
                  <Select value={this.state.form.cadreResettlementMode.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'cadreResettlementMode')}>
                    {
                      this.state.dicts.map(el => {
                        if (el.code == 'cadre_resettlement_mode') {
                          let arr = [];
                          if (el.children) {
                            arr = el.children.map((item) => {
                              return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)} />
                            })
                          }
                          return arr;
                        }
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
            </Col> : null)}

            <Col sm={{ span: 24 }} style={{ "display": "flex" }}>
              <Col sm={{ span: 7 }}>
                <Form.Item label="是否优抚对象" labelWidth="120" props="preferentialTreatmentObjectStatus" required={true}>
                  <Select value={this.state.form.preferentialTreatmentObjectStatus.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'preferentialTreatmentObjectStatus')}>
                    {
                      this.state.dicts.map(el => {
                        if (el.code == 'yes_no') {
                          let arr = [];
                          if (el.children) {
                            arr = el.children.map((item) => {
                              return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)} />
                            })
                          }
                          return arr;
                        }
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col sm={{ span: 7 }}>
                {form.preferentialTreatmentObjectStatus == "2" ? <Form.Item label="优抚对象类别" labelWidth="120" props="preferentialTreatmentObjectCategory" required={true}>
                  <Select value={this.state.form.preferentialTreatmentObjectCategory.toString()}
                  placeholder="请选择" onChange={(e)=>{    this.selectchange(e,this);      }}>
                    {
                      this.state.dicts.map(el => {
                        if (el.code == 'preferential_treatment_object_category') {
                          let arr = [];
                          if (el.children) {
                            // 0: {id: '72', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '1', dictValue: '伤残人员', …}
                            // 1: {id: '73', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '2', dictValue: '在乡老复员军人', …}
                            // 2: {id: '74', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '3', dictValue: '带病回乡退伍军人', …}
                            // 3: {id: '75', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '4', dictValue: '参战退役人员', …}
                            // 4: {id: '76', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '5', dictValue: '参试(涉核)退役人员', …}
                            // 5: {id: '77', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '6', dictValue: '烈士老年子女', …}
                            // 6: {id: '78', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '7', dictValue: '年满60周岁农村籍退役士兵', …}
                            // 7: {id: '79', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '8', dictValue: '烈土遗属', …}
                            // 8: {id: '80', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '9', dictValue: '因公牺牲军人遗属', …}
                            // 9: {id: '81', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '10', dictValue: '病故军人遗属', …}
                            // 10: {id: '82', parentId: '71', code: 'preferential_treatment_object_category', dictKey: '11', dictValue: '其他', …}
                            arr = el.children.map((item) => {
                              if ((userType == 1 | userType == 2) & item.dictKey > 5) {
                                // 禁用该选项
                                return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)}  disabled={true} />
                              } else {
                                return <Select.Option key={item.dictKey}   label={item.dictValue} value={Number(item.dictKey)}   />
                              }

                            })
                          }
                          return arr;
                        }
                      })
                    }
                  </Select>
                </Form.Item> : null}
              </Col>
            </Col>



























            <Col sm={{ span: 24 }}>
              <Form.Item label="留言标题" props="messageTitle" required={true}>
                <Input placeholder="请输入留言主题" value={this.state.form.messageTitle} onChange={this.onChange.bind(this, 'messageTitle')} maxLength={18}></Input>
              </Form.Item>
            </Col>
            <Col sm={{ span: 24 }}>
              <Form.Item label="留言正文" props="messageBody" required={true}>
                <Input
                  type="textarea"
                  autosize={{ minRows: 10, maxRows: 20 }}
                  // rows={10}
                  resize='none'
                  value={this.state.form.messageBody}
                  onChange={this.onChange.bind(this, 'messageBody')}
                  placeholder="请输入内容，不超过500个字"
                  maxLength={1000}
                />
              </Form.Item>
            </Col>


            <Col sm={{ span: 7 }}>
              <Form.Item label="上传附件" props="category" required={true}>
                <Upload
                  className="upload-demo"
                  action={Request.getDebugUrl() + 'swsmart-file/fileServer/uploadSingle'}
                  onPreview={file => this.handlePreview(file)}
                  onRemove={(file, fileList) => this.handleRemove(file, fileList)}
                  fileList={fileList}
                  onSuccess={(response, file, fileList) => this.uploadSuccess(response, file, fileList)}
                  limit={3}
                  ref={this.uploadRef}
                  onExceed={(files, fileList) => {
                    Message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
                  }}
                >
                  <Button size="small" type="primary">选择文件</Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col sm={{ span: 6 }}>
              <Form.Item label="业务类别" props="businessCategory" required={true}>
                <Select value={this.state.form.businessCategory.toString()} placeholder="请选择" onChange={this.onChange.bind(this, 'businessCategory')}>
                  {
                    this.state.dicts.map(el => {
                      if (el.code == 'business_category') {
                        let arr = [];
                        if (el.children) {
                          arr = el.children.map((item) => {
                            return <Select.Option key={item.dictKey} label={item.dictValue} value={Number(item.dictKey)} />
                          })
                        }
                        return arr;
                      }
                    })
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col sm={{ span: 24 }}>
              {/* <Form.Item label="验证码" props="yzm" required={true} className="yzmCss">
                  <Input placeholder="" value={this.state.form.yzm} onChange={this.onChange.bind(this, 'yzm')} onBlur={this.onBlur.bind(this, 'identityAccount')} style={{width : 160}}></Input>
                  <div className="yzmImg">
                    <div style={yzmImgStyle}></div>
                  </div>
                  <span className="shuaxin">刷新</span>
                </Form.Item> */}
              <Form.Item label="验证码" props="veriCode" required={true} className="yzmCss">
                <Input placeholder="" value={this.state.form.veriCode} onChange={this.onChange.bind(this, 'veriCode')} style={{ width: 160 }}></Input>
                <div className="yzmImg">
                  <div style={yzmImgStyle}></div>
                </div>
                <span className="shuaxin" onClick={this.changeVCode.bind(this)}>刷新</span>
              </Form.Item>
            </Col>
          </Row>
          <div className="form-footer">
            <div className="form-btn" onClick={this.handleSubmit.bind(this)}>提交信息</div>
            <div className="form-btn form-btn1" onClick={this.handleReset.bind(this)}>重置信息</div>
          </div>
        </Form>
      </div>
    );
  }
}
